import { invokeApi } from ".";
import * as endPoints from "../constants/ApiEndpoints";
import { APICall } from "../helpers/API/APICalls";
import { getFromEncLocalStorage } from "../helpers/Utils/Utils";

export const getTicker = async () => {
  const token = getFromEncLocalStorage("token");
  const data = await invokeApi(endPoints.getTicker, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    }

  });

  return data;
};

export const getTickerV2 = async () => {
  const data = await APICall(endPoints.getTickerV2, null);
  return data;
};

const TickerService = { getTicker };
export default TickerService;